import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BaasLink } from '../../../../baas-link/baas-link';
import { BaasLinkOptions } from '../../../../baas-link/baas-link-options.type';
import { BarLayoutService } from '../../bar-layout.service';

@Component({
    selector: 'bar-layout-menu-external-links',
    templateUrl: './bar-layout-menu-external-links.component.html',
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BaasLink, AsyncPipe]
})
export class BarLayoutMenuExternalLinksComponent {
    readonly layout = inject(BarLayoutService);

    isExternal(link: BaasLinkOptions): boolean {
        return link?.target === '_blank';
    }
}
